import * as R from 'ramda';
import { createSelector } from 'reselect';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('tollCharges');

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => itemList,
);

const makeSelectDriverList = () => createSelector(
  store,
  ({ driverList }) => driverList,
);

const makeSelectTruckList = () => createSelector(
  store,
  ({ truckList }) => truckList,
);

const makeSelectTruckGuid = () => createSelector(
  store,
  ({ truckGuid }) => truckGuid,
);

const makeSelectDriverGuid = () => createSelector(
  store,
  ({ driverGuid }) => driverGuid,
);

const makeSelectSelectedList = () => createSelector(
  store,
  R.compose(
    R.keys,
    R.filter(R.prop('selected')),
    R.propOr([], 'itemList'),
  ),
);

const makeSelectAdditionalSearchCriteria = () => createSelector(
  store,
  R.propOr([], 'additionalSearchCriteria'),
);

export {
  makeSelectItemList,
  makeSelectTruckList,
  makeSelectTruckGuid,
  makeSelectDriverGuid,
  makeSelectUsedReport,
  makeSelectDriverList,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectSelectedList,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectAdditionalSearchCriteria,
};
